const resources = {
  nl: {
    translation: require('./nl/translation.json'),
  },
  en: {
    translation: require('./en/translation.json'),
  },
}

export default resources
